import { setContext } from '@apollo/client/link/context';
import { from, ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL,
});

const authentication = { 'x-api-key': process.env.REACT_APP_API_KEY };

export const authLink = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...authentication,
    },
  };
});

export const client = new ApolloClient({
  defaultOptions: {
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    watchQuery: {
      fetchPolicy: 'network-only',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
  link: from([authLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false,
    dataIdFromObject: (o) => (o._id ? `${o.__typename}:${o._id}` : ''),
  }),
});
